<template lang="pug">
#messgae
  .container.custom_container_lg
    .row
      breadcrumb
  section.container.i_mt_14.i_mt_md_10
    .row.text-center.flex-column
      h2.i_h2_title 重大訊息
    .row.i_mt_8
      .col-12.table_head.d-flex
        .date_block 發言日期
        .time_block 發言時間
        .subject_block 主旨
    .row
      table-item(
        v-for="(tableItem, index) in currentImportantNewsList",
        :key="index",
        :tableItem="tableItem"
      )

    .row
      .col-12.text.center.justify-content-center
        b-pagination(
          v-model="currentPage",
          :total-rows="totalRows",
          :per-page="perPage",
          first-number,
          last-number
        )
  dedicated-line
</template>

<script>
import TableItem from "@/components/about_us/public_info/TableItem";
import { getImportantNews } from "@/json/about_us";
import DedicatedLine from "@/components/customer_service/DedicatedLine";
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "AboutUsPublicInfoMessage",
  components: {
    "table-item": TableItem,
    "dedicated-line": DedicatedLine,
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      importantNews: {},
      currentImportantNewsList: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
    };
  },
  watch: {
    currentPage() {
      this.getCurrentList();
    },
  },
  created() {
    this.getImportantNews();
  },
  methods: {
    getImportantNews() {
      getImportantNews().then((response) => {
        this.importantNews = response.data;
        this.totalRows = this.importantNews.ImportantNewsList.length;
        this.getCurrentList();
      });
    },
    getCurrentList() {
      this.currentImportantNewsList = [];
      let number = this.perPage * this.currentPage;
      this.currentImportantNewsList = this.importantNews.ImportantNewsList.slice(
        number - this.perPage,
        number
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/profile";
@import "@/assets/style/about_us/public_info/message";
@import "@/assets/style/common/pagination";

.dedicated_line {
  transform: translateY(124px);
}

@media (max-width: 991px) {
  .dedicated_line {
    transform: translateY(82px);
  }
}

@media (max-width: 575px) {
  .dedicated_line {
    transform: translateY(13vw);
  }
}
</style>
